<template>
  <b-container class="content">
    <h1>{{ $t('wifi.manualSSID') }}</h1>
    <div>
      <b-form @submit="onSubmit">
        <b-form-group id="ssid" :label="$t('wifi.ssid')" label-for="ssid">
          <b-form-input
            id="ssid"
            v-model="form.ssid"
            type="text"
            required
            :placeholder="$t('wifi.ssidEnter')"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="encryption" :label="$t('wifi.encryption')" label-for="encryption">
          <b-form-select
            id="encryption"
            v-model="form.encryption"
            :options="encryption_options"
            required
          ></b-form-select>
        </b-form-group>

        <b-button type="submit" variant="primary">{{ $t('wifi.continue') }}</b-button>
      </b-form>
    </div>
  </b-container>
</template>

<script>

export default {
  name: 'SetupSelectWifi',
  props: ['mac'],
  data() {
    return {
      form: {
        ssid: '',
        encryption: 'wpa2',
        authentication_suites: '',
        scan_ssid: '1',
      },
      encryption_options: [
        {value: 'off', text: this.$t('wifi.encryptionNone')},
        {value: 'wpa2', text: this.$t('wifi.encryptionWPA2')},
        {value: 'wpa2-enterprise', text: this.$t('wifi.encryptionWPA2Enterprise')},
      ],
    }
  },
  methods: {
    onSubmit() {
      if(this.form.encryption === 'wpa2-enterprise') {
        this.form.authentication_suites = '802.1x';
      }
      this.$emit('select_wifi', this.form);
    }
  }
}
</script>
